export default function transformDataToDropdownFormat(dataArray, format) {
  return dataArray.map((item) => ({
    label: item?.label || item?.title || item?.name || "بدون عنوان",
    value: `${format}-${item.value}`,
  }));
}
